import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { lowHeightScreens } from '../../../common/fontElements';

export const Container = styled.div`
  display: flex;
  flex: 1 1 0;
  padding: 100px 30px 50px 30px;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.baseBackground};

  @media (max-height: ${lowHeightScreens}) {
    padding: 50px 30px;
  }
`;

export const InfoWrapper = styled.div`
  padding: 0 30px;
  width: 100%;
`;

export const Title = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 14px;
  color: ${colors.black4};

  @media (max-height: ${lowHeightScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 11px;
  color: ${colors.darkGray1};

  @media (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;
